<div class="main-content">

  <!-- ================= Header + filtro magazzino ================= -->
  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--amber">
        <i class="fas fa-pallet"></i>
      </div>
      <div>
        <h1 class="main-title">Giacenze Magazzino</h1>
        <p class="main-subtitle">Colli fermi nei magazzini: totale per magazzino e dettaglio dei singoli colli</p>
      </div>
    </div>

    <div class="platform-filter">
      <div class="platform-filter-icon">
        <i class="fas fa-warehouse"></i>
      </div>
      <div class="platform-filter-body">
        <div class="platform-filter-label">Magazzino</div>

        <div class="platform-filter-locked" *ngIf="isSingleWarehouse"
             [title]="'Magazzino assegnato: ' + selectedWarehouseLabel">
          <span class="platform-filter-name">{{ selectedWarehouseLabel }}</span>
          <i class="fas fa-lock ms-2"></i>
        </div>

        <div class="platform-filter-select" *ngIf="!isSingleWarehouse">
          <app-searchable-select
                  [(ngModel)]="warehouseCode"
                  [options]="warehouseSelectOptions"
                  [multiple]="false"
                  [allOptionLabel]="canSeeAllWarehouses ? 'Tutti i magazzini' : 'Tutti i miei magazzini'"
                  icon="fas fa-warehouse"
                  searchPlaceholder="Cerca magazzino..."
                  (valueChange)="onWarehouseChange()">
          </app-searchable-select>
        </div>

        <div class="platform-filter-hint platform-filter-hint--info" *ngIf="isSummaryMode && !isSingleWarehouse">
          Nessun magazzino selezionato: vedi il totale per ogni magazzino
        </div>
      </div>
    </div>
  </div>

  <!-- ================= Barra vista / ordinamento riepilogo ================= -->
  <div class="platform-status-bar" role="group" aria-label="Vista giacenza">
    <ng-container *ngIf="isSummaryMode">
      <span class="platform-status-bar-label">Ordina</span>
      <button type="button" class="platform-status-btn platform-status-btn--sort"
              *ngFor="let opt of summarySortOptions"
              [class.active]="isSummarySortOptionActive(opt)"
              (click)="applySummarySortOption(opt)">
        <i class="fas" [ngClass]="opt.icon"></i>
        {{ opt.label }}
        <i class="fas fa-check ms-1" *ngIf="isSummarySortOptionActive(opt)"></i>
      </button>
    </ng-container>

    <ng-container *ngIf="!isSummaryMode">
      <button type="button" class="stock-back-btn" *ngIf="!isSingleWarehouse" (click)="backToSummary()"
              matTooltip="Torna al totale per magazzino">
        <i class="fas fa-chevron-left"></i>
        Tutti i magazzini
      </button>
      <span class="stock-current-warehouse">
        <span class="wh-code">{{ selectedWarehouseShortName }}</span>
        <span class="text-muted">{{ selectedWarehouse?.warehouseName }}</span>
      </span>
    </ng-container>

    <button type="button" class="stock-toggle"
            [class.active]="includeNotConfirmed"
            (click)="toggleIncludeNotConfirmed()"
            matTooltip="Mostra anche i colli affidati al primo magazzino ma non ancora confermati dal picking di ingresso"
            matTooltipPosition="above">
      <span class="stock-toggle-switch"><span class="stock-toggle-knob"></span></span>
      Includi affidati non confermati
    </button>
  </div>

  <!-- ================= Filtri ================= -->
  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri</h3>
        </div>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-primary-subtle text-primary filters-active-badge" *ngIf="hasActiveFilters()">
            <i class="fas fa-sliders-h me-1"></i> Filtri attivi
          </span>
          <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="showFilters = !showFilters"
                  [title]="showFilters ? 'Comprimi' : 'Espandi'">
            <i class="fas" [ngClass]="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body" [hidden]="!showFilters">
      <div class="row g-3">

        <div class="col-md-3">
          <label class="form-label">Data Affido Da</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="!!dateError">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #parcelDateStartInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('parcelDateStart')"
                   (click)="openDatePicker('parcelDateStart')"
                   (focus)="openDatePicker('parcelDateStart')"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('parcelDateStart', -1)" title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('parcelDateStart')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('parcelDateStart', 1)" title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('parcelDateStart')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data Affido A</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="!!dateError">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #parcelDateEndInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('parcelDateEnd')"
                   (click)="openDatePicker('parcelDateEnd')"
                   (focus)="openDatePicker('parcelDateEnd')"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('parcelDateEnd', -1)" title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('parcelDateEnd')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('parcelDateEnd', 1)" title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('parcelDateEnd')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice Collo</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-box filter-icon"></i>
            <input type="text" class="filter-input" maxlength="99"
                   [(ngModel)]="searchParcelCode" (keyup.enter)="applyFilters()"
                   placeholder="Cerca per codice collo o barcode...">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice Bolla</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-barcode filter-icon"></i>
            <input type="text" class="filter-input" maxlength="99"
                   [(ngModel)]="searchWaybillCode" (keyup.enter)="applyFilters()"
                   placeholder="Cerca per codice bolla...">
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="dateError">
        <div class="col-12">
          <div class="rt-date-error" role="alert">
            <div class="rt-date-error-icon">
              <i class="fas fa-calendar-xmark"></i>
            </div>
            <div class="rt-date-error-body">
              <div class="rt-date-error-title">Controlla i filtri</div>
              <div class="rt-date-error-text">{{ dateError }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span class="stock-filters-note">
              <i class="fas fa-circle-info me-1"></i>
              Senza date vengono considerati tutti i colli ancora in giacenza, a prescindere dalla data di affido
            </span>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetFilters()" title="Azzera filtri">
                <i class="fas fa-undo me-1"></i> Azzera filtri
              </button>
              <button type="button" class="btn btn-primary btn-sm" (click)="applyFilters()" [disabled]="isLoading" title="Applica filtri">
                <i class="fas" [ngClass]="isLoading ? 'fa-spinner fa-spin me-1' : 'fa-search me-1'"></i>
                Applica filtri
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ================= Resoconto ================= -->
  <div id="summary-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-chart-bar header-icon"></i>
          <h3>Resoconto</h3>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleReportCollapsed()"
                [title]="isReportCollapsed ? 'Espandi' : 'Comprimi'">
          <i class="fas" [ngClass]="isReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>
    <div class="card-body" *ngIf="!isReportCollapsed">
      <div class="sm-metrics-grid">

        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--green">
            <i class="fas fa-cube"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ totals.totalParcels | number }}</ng-container>
            </div>
            <div class="sm-metric-label">
              Colli in giacenza
              <span class="stock-metric-split" *ngIf="!isLoading && includeNotConfirmed && totals.notConfirmedParcels > 0">
                di cui {{ totals.notConfirmedParcels | number }} non confermati
              </span>
            </div>
          </div>
        </div>

        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--orange">
            <i class="fas fa-weight"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ getIntegerPart(totals.totalWeight, '1.3-3') }}<span class="sm-metric-decimals">{{ getDecimalPart(totals.totalWeight, '1.3-3') }}</span></ng-container>
            </div>
            <div class="sm-metric-label">Peso Totale (kg)</div>
          </div>
        </div>

        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--yellow">
            <i class="fas fa-expand-arrows-alt"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ getIntegerPart(totals.totalVolume, '1.4-4') }}<span class="sm-metric-decimals">{{ getDecimalPart(totals.totalVolume, '1.4-4') }}</span></ng-container>
            </div>
            <div class="sm-metric-label">Volume Totale (m3)</div>
          </div>
        </div>

        <div class="sm-metric-card">
          <div class="sm-metric-icon sm-metric-icon--rose">
            <i class="fas fa-hourglass-half"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">
                {{ totals.averageStockDays != null ? (totals.averageStockDays | number:'1.0-1') : '-' }}
              </ng-container>
            </div>
            <div class="sm-metric-label">
              Giorni medi di giacenza
              <span class="stock-metric-split" *ngIf="!isLoading && totals.maxStockDays != null">
                il più datato è fermo da {{ getStockDaysLabel(totals.maxStockDays) }}
              </span>
            </div>
          </div>
        </div>

        <div class="sm-metric-card" *ngIf="isSummaryMode">
          <div class="sm-metric-icon sm-metric-icon--blue-soft">
            <i class="fas fa-warehouse"></i>
          </div>
          <div class="sm-metric-body">
            <div class="sm-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoading"></span>
              <ng-container *ngIf="!isLoading">{{ totals.warehousesWithStock | number }}</ng-container>
            </div>
            <div class="sm-metric-label">Magazzini con giacenza</div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- ================= Tabella ================= -->
  <div id="stock-section" class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="header-title">
          <i class="fas header-icon" [ngClass]="isSummaryMode ? 'fa-warehouse' : 'fa-boxes-stacked'"></i>
          <h3 *ngIf="isSummaryMode">Giacenza per magazzino</h3>
          <h3 *ngIf="!isSummaryMode">Colli in giacenza a {{ selectedWarehouseShortName }}</h3>
        </div>

        <div class="controls-container">
          <button type="button" class="stock-toggle stock-toggle--compact me-1" *ngIf="isSummaryMode"
                  [class.active]="onlyWithStock"
                  (click)="toggleOnlyWithStock()">
            <span class="stock-toggle-switch"><span class="stock-toggle-knob"></span></span>
            Solo con giacenza
          </button>

          <div class="btn-group btn-group-sm pagination-selector" role="group" aria-label="Elementi per pagina">
            <button type="button" class="btn"
                    *ngFor="let size of pageSizeOptions"
                    [ngClass]="itemsPerPage === size ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(size)"
                    [title]="size + ' elementi per pagina'">
              {{ size }}
            </button>
          </div>

          <button type="button" class="header-action-btn me-1"
                  (click)="exportExcel()"
                  [disabled]="totals.totalParcels === 0 || isExportingExcel"
                  [matTooltip]="isSummaryMode ? 'Esporta Excel: tutti i colli in giacenza di tutti i magazzini' : 'Esporta Excel: tutti i colli in giacenza a ' + selectedWarehouseShortName">
            <i class="fas fa-spinner fa-spin text-success" *ngIf="isExportingExcel"></i>
            <i class="fas fa-file-excel text-success" *ngIf="!isExportingExcel"></i>
          </button>

          <div class="counter-display">
            <span class="badge bg-light text-muted" [title]="isSummaryMode ? 'Magazzini' : 'Colli in giacenza'">
              <i class="fas me-1" [ngClass]="isSummaryMode ? 'fa-warehouse' : 'fa-cube'"></i>
              {{ totalRecords | number }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body p-0">

      <!-- ---------- Riepilogo per magazzino ---------- -->
      <div class="table-responsive" *ngIf="isSummaryMode && !isLoading" (scroll)="closeOpenColumnFilterOnScroll()">
        <table class="table rt-table stock-summary-table mb-0">
          <thead>
          <tr>
            <th scope="col" class="sortable-th" (click)="setSummarySort('warehouseShortName')">
              <div class="wm-th-content">
                Magazzino
                <i class="fas" [ngClass]="getSummarySortIcon('warehouseShortName')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('warehouseShortName', 'summary')"
                   (click)="toggleColumnFilter('warehouseShortName', $event, 'summary')"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSummarySort('warehouseName')">
              <div class="wm-th-content">
                Descr. Magazzino
                <i class="fas" [ngClass]="getSummarySortIcon('warehouseName')"></i>
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('warehouseName', 'summary')"
                   (click)="toggleColumnFilter('warehouseName', $event, 'summary')"></i>
              </div>
            </th>
            <th scope="col">
              <div class="wm-th-content">
                Tipo
                <i class="fas fa-filter wm-col-filter-icon" [class.active]="isColumnFilterActive('warehouseType', 'summary')"
                   (click)="toggleColumnFilter('warehouseType', $event, 'summary')"></i>
              </div>
            </th>
            <th scope="col" class="text-center sortable-th" (click)="setSummarySort('totalParcels')">
              <div class="wm-th-content wm-th-content--center">
                Colli in Giacenza
                <i class="fas" [ngClass]="getSummarySortIcon('totalParcels')"></i>
              </div>
            </th>
            <th scope="col" class="text-end sortable-th" *ngIf="includeNotConfirmed" (click)="setSummarySort('notConfirmedParcels')">
              <div class="wm-th-content wm-th-content--end">
                Non Confermati
                <i class="fas" [ngClass]="getSummarySortIcon('notConfirmedParcels')"></i>
              </div>
            </th>
            <th scope="col" class="text-end sortable-th" (click)="setSummarySort('totalWeight')">
              <div class="wm-th-content wm-th-content--end">
                Peso (kg)
                <i class="fas" [ngClass]="getSummarySortIcon('totalWeight')"></i>
              </div>
            </th>
            <th scope="col" class="text-end sortable-th" (click)="setSummarySort('totalVolume')">
              <div class="wm-th-content wm-th-content--end">
                Volume (m3)
                <i class="fas" [ngClass]="getSummarySortIcon('totalVolume')"></i>
              </div>
            </th>
            <th scope="col" class="sortable-th" (click)="setSummarySort('oldestStockDate')">
              <div class="wm-th-content">
                Giacenza Più Datata
                <i class="fas" [ngClass]="getSummarySortIcon('oldestStockDate')"></i>
              </div>
            </th>
            <th scope="col" class="text-center sortable-th" (click)="setSummarySort('maxStockDays')">
              <div class="wm-th-content wm-th-content--center">
                Giorni Max
                <i class="fas" [ngClass]="getSummarySortIcon('maxStockDays')"></i>
              </div>
            </th>
            <th scope="col" class="rt-expand-th"></th>
          </tr>
          </thead>

          <tbody>
          <tr *ngIf="summaryRows.length === 0 && !dateError">
            <td [attr.colspan]="includeNotConfirmed ? 10 : 9" class="text-center text-muted py-5">
              <i class="fas fa-inbox me-2"></i>
              Nessun magazzino trovato. Modifica i filtri e riprova.
            </td>
          </tr>
          <tr *ngFor="let row of summaryRows; trackBy: trackByWarehouse"
              class="rt-row stock-summary-row"
              [class.stock-summary-row--empty]="row.totalParcels === 0"
              [class.stock-summary-row--disabled]="!row.warehouseCode"
              (click)="openWarehouse(row)">
            <td>
              <span class="wh-code">{{ row.warehouseShortName || row.warehouseCode || 'N/D' }}</span>
            </td>
            <td class="rt-strong">{{ row.warehouseName || '-' }}</td>
            <td>
              <span class="wh-type-chip" *ngFor="let t of getWarehouseTypes(row.warehouseType)">{{ t }}</span>
              <span class="text-muted" *ngIf="getWarehouseTypes(row.warehouseType).length === 0">-</span>
            </td>
            <td class="text-center">
              <span class="stock-total-value" [class.stock-total-value--zero]="row.totalParcels === 0">{{ row.totalParcels | number }}</span>
            </td>
            <td class="text-end rt-date" *ngIf="includeNotConfirmed">{{ row.notConfirmedParcels | number }}</td>
            <td class="text-end rt-date">{{ row.totalWeight | number:'1.0-2' }}</td>
            <td class="text-end rt-date">{{ row.totalVolume | number:'1.0-4' }}</td>
            <td>
              <span class="rt-date" *ngIf="row.oldestStockDate; else noOldest">{{ row.oldestStockDate | date:'dd/MM/yy HH:mm' }}</span>
              <ng-template #noOldest><span class="text-muted">-</span></ng-template>
            </td>
            <td class="text-center">
              <span [ngClass]="getStockDaysClass(row.maxStockDays)" *ngIf="row.maxStockDays != null; else noMaxDays">
                {{ getStockDaysLabel(row.maxStockDays) }}
              </span>
              <ng-template #noMaxDays><span class="text-muted">-</span></ng-template>
            </td>
            <td class="text-center">
              <button type="button" class="wm-expand-btn" *ngIf="row.warehouseCode"
                      (click)="$event.stopPropagation(); openWarehouse(row)"
                      [matTooltip]="'Vedi i colli in giacenza a ' + (row.warehouseShortName || row.warehouseCode)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- ---------- Dettaglio colli del magazzino ---------- -->
      <div class="table-responsive" *ngIf="!isSummaryMode && !isLoading" (scroll)="closeOpenColumnFilterOnScroll()">
        <table class="table rt-table mb-0">
          <thead>
          <tr>
            <th scope="col" *ngFor="let col of parcelColumns"
                [class.sortable-th]="col.sortable"
                [class.text-center]="col.align === 'center'"
                [class.text-end]="col.align === 'end'"
                (click)="col.sortable && setSort(col.field)">
              <div class="wm-th-content"
                   [class.wm-th-content--center]="col.align === 'center'"
                   [class.wm-th-content--end]="col.align === 'end'">
                {{ col.label }}
                <i class="fas" *ngIf="col.sortable" [ngClass]="getSortIcon(col.field)"></i>
                <i class="fas fa-filter wm-col-filter-icon" *ngIf="col.filterable"
                   [class.active]="isColumnFilterActive(col.field)"
                   (click)="toggleColumnFilter(col.field, $event)"></i>
              </div>
            </th>
          </tr>
          </thead>

          <tbody>
          <tr *ngIf="parcels.length === 0 && !dateError">
            <td [attr.colspan]="parcelColumns.length" class="text-center text-muted py-5">
              <i class="fas fa-inbox me-2"></i>
              Nessun collo in giacenza. Modifica i filtri e riprova.
            </td>
          </tr>
          <tr *ngFor="let p of parcels; trackBy: trackByParcel" class="rt-row">
            <td *ngFor="let col of parcelColumns"
                [class.text-center]="col.align === 'center'"
                [class.text-end]="col.align === 'end'">
              <ng-container [ngSwitch]="col.field">

                <ng-container *ngSwitchCase="'stockStatus'">
                  <span [ngClass]="stockStatusMeta[p.stockStatus]?.css || 'stock-badge'"
                        [matTooltip]="stockStatusMeta[p.stockStatus]?.tooltip || ''">
                    <i class="fas" [ngClass]="stockStatusMeta[p.stockStatus]?.icon"></i>
                    {{ getStockStatusLabel(p.stockStatus) }}
                  </span>
                </ng-container>

                <ng-container *ngSwitchCase="'parcelCode'">
                  <div class="d-flex align-items-center gap-1">
                    <span class="rt-code rt-strong">{{ p.parcelCode }}</span>
                    <i class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(p.parcelCode, 'Codice Collo')"
                       [matTooltip]="'Copia codice collo: ' + p.parcelCode"></i>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'waybillCode'">
                  <div class="d-flex align-items-center gap-1" *ngIf="p.waybillCode; else dash">
                    <span class="rt-code">{{ p.waybillCode }}</span>
                    <i class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(p.waybillCode, 'Codice Bolla')"
                       [matTooltip]="'Copia codice bolla: ' + p.waybillCode"></i>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'clientName'">
                  <span *ngIf="p.clientName; else dash">{{ p.clientName }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'parcelDate'">
                  <span class="rt-date" *ngIf="p.parcelDate; else dash">{{ p.parcelDate | date:'dd/MM/yy HH:mm' }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'stockSince'">
                  <span class="rt-date" *ngIf="p.stockSince; else notEntered">{{ p.stockSince | date:'dd/MM/yy HH:mm' }}</span>
                  <ng-template #notEntered>
                    <span class="text-muted stock-since-missing" matTooltip="Collo affidato: ingresso in magazzino non ancora registrato, i giorni partono dalla data di affido">
                      da affido
                    </span>
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'stockDays'">
                  <span [ngClass]="getStockDaysClass(p.stockDays)">{{ getStockDaysLabel(p.stockDays) }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'parcelEstimatedDeliveryDate'">
                  <span class="rt-date" *ngIf="p.parcelEstimatedDeliveryDate; else dash">{{ p.parcelEstimatedDeliveryDate | date:'dd/MM/yy HH:mm' }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'dealerName'">
                  <div class="d-flex align-items-center gap-1" *ngIf="p.dealerName; else dash">
                    <span class="rt-strong">{{ p.dealerName }}</span>
                    <i class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(p.dealerName, 'Ragione Sociale')"
                       [matTooltip]="'Copia ragione sociale: ' + p.dealerName"></i>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'dealerOperatingAddressStreet'">
                  <span *ngIf="p.dealerOperatingAddressStreet; else dash">{{ p.dealerOperatingAddressStreet }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'dealerOperatingAddressCity'">
                  <span *ngIf="p.dealerOperatingAddressCity; else dash">{{ p.dealerOperatingAddressCity }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'dealerOperatingAddressProvince'">
                  <span *ngIf="p.dealerOperatingAddressProvince; else dash">{{ p.dealerOperatingAddressProvince }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'parcelDescription'">
                  <span *ngIf="getParcelDescription(p); else dash">{{ getParcelDescription(p) }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'parcelType'">
                  <span class="parcel-type-badge"
                        [class.urgent]="isUrgentType(p.parcelType)"
                        [class.stock]="isStockType(p.parcelType)"
                        [class.unknown]="!isUrgentType(p.parcelType) && !isStockType(p.parcelType)">
                    {{ getParcelTypeLabel(p.parcelType) }}
                  </span>
                </ng-container>

                <ng-container *ngSwitchCase="'parcelWeight'">
                  <span class="rt-date">{{ p.parcelWeight != null ? (p.parcelWeight | number:'1.0-2') : '-' }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'parcelVolume'">
                  <span class="rt-date">{{ p.parcelVolume != null ? (p.parcelVolume | number:'1.0-4') : '-' }}</span>
                </ng-container>

              </ng-container>
            </td>
          </tr>
          </tbody>
        </table>
        <ng-template #dash><span class="text-muted">-</span></ng-template>
      </div>

      <!-- ---------- Popover filtro a imbuto ---------- -->
      <div class="wm-col-filter-popover" *ngIf="openColumnFilterKey"
           [style.top]="columnFilterPopoverStyle.top" [style.left]="columnFilterPopoverStyle.left"
           (click)="$event.stopPropagation()">
        <div class="wm-col-filter-section-label">Filtra per valore</div>
        <input type="text" [(ngModel)]="columnValueSearchTerm" placeholder="Cerca valore..." class="wm-col-filter-value-search">
        <div class="wm-col-filter-value-loading" *ngIf="columnDistinctValuesLoading">
          <span class="spinner-border spinner-border-sm"></span> Caricamento valori...
        </div>
        <div class="wm-col-filter-value-list" *ngIf="!columnDistinctValuesLoading">
          <label class="wm-col-filter-value-item wm-col-filter-value-item--all">
            <input type="checkbox" [checked]="areAllVisibleColumnValuesSelected()" (change)="toggleSelectAllColumnValues()">
            Seleziona tutto
          </label>
          <label class="wm-col-filter-value-item" *ngFor="let v of getFilteredColumnDistinctValues()">
            <input type="checkbox" [checked]="isColumnValueChecked(v)" (change)="toggleColumnValue(v)">
            {{ getColumnValueLabel(v) }}
          </label>
          <div class="wm-col-filter-value-empty" *ngIf="getFilteredColumnDistinctValues().length === 0">Nessun valore trovato</div>
        </div>
        <div class="wm-col-filter-popover-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="clearColumnFilter()">Azzera</button>
          <button type="button" class="btn btn-primary" (click)="applyColumnValueFilter()">Applica selezione</button>
        </div>
      </div>

      <!-- ---------- Paginazione ---------- -->
      <div class="pagination-container" *ngIf="!isLoading && totalRecords > 0">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)"
                  [disabled]="currentPage === 1" aria-label="Precedente" title="Precedente">
            <i class="fas fa-chevron-left"></i>
          </button>
          <div class="page-numbers">
            <button *ngFor="let page of getPageNumbers(); trackBy: trackByPageNumber"
                    class="pagination-number"
                    [class.active]="page === currentPage"
                    (click)="onPageChange(page)"
                    [attr.aria-label]="'Pagina ' + page"
                    [title]="'Vai alla pagina ' + page">
              {{ page }}
            </button>
          </div>
          <span class="pagination-info">
            {{ rangeStart }} - {{ rangeEnd }} di {{ totalRecords }}
          </span>
          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                  [disabled]="currentPage === getTotalPages()" aria-label="Successivo" title="Successivo">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
    <span class="visually-hidden">Caricamento...</span>
  </div>
</div>

<!-- ================= Indicatore download Excel ================= -->
<div class="stock-export-toast" *ngIf="isExportingExcel" role="status" aria-live="polite">
  <div class="stock-export-icon">
    <i class="fas fa-file-excel"></i>
  </div>
  <div class="stock-export-body">
    <div class="stock-export-title">Download Excel in corso</div>
    <div class="stock-export-text">
      Estrazione di {{ exportingCount | number }} colli in giacenza per {{ exportingScope }}
    </div>
    <div class="stock-export-progress"><span></span></div>
  </div>
</div>